module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Poll Details",
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 py-4 flex-grow overflow-y-auto"
  }, [_c('p', {
    staticClass: "text-lg font-semibold"
  }, [_vm._v(_vm._s(_vm.selectedPoll.question))]), _vm._v(" "), _vm._l((_vm.selectedPoll.answers), function(answer, index) {
    return _c('div', {
      key: ("voting-" + answer + "-" + index)
    }, [_c('div', {
      staticClass: "relative ellipsis-text w-full rounded h-10 px-3 mt-4 flex items-center justify-between bg-gray-100",
      class: {
        'font-semibold': _vm.user_selections.includes(answer)
      }
    }, [_c('div', {
      staticClass: "rounded absolute h-full left-0 bg-primary",
      class: {
        'rounded-tr-none rounded-br-none': (_vm.vote_counts[answer] * 100 || 0) / _vm.total_votes_array.length < 100
      },
      style: ([{
        width: (_vm.vote_counts[answer] * 100 || 0) / _vm.total_votes_array.length + '%'
      }])
    }), _vm._v(" "), _c('span', {
      staticClass: "truncate z-10"
    }, [_vm._v(_vm._s(answer))]), _vm._v(" "), _c('div', {
      staticClass: "truncate z-10"
    }, [_c('span', {
      staticClass: "text-gray-500 text-xs mr-2"
    }, [_vm._v("\n            " + _vm._s(_vm.vote_counts[answer] || '0') + "\n            " + _vm._s(_vm.vote_counts[answer] === 1 ? 'vote' : 'votes') + "\n          ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(Math.round((_vm.vote_counts[answer] * 100 || 0) / (_vm.total_votes_array.length || 1)) + '%'))])])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.selectedPoll.votes && _vm.selectedPoll.votes.length && _vm.vote_counts[answer] > 0) ? _c('div', {
      key: _vm.componentKey,
      staticClass: "px-3"
    }, [_c('button', {
      staticClass: "m-0 text-xs text-gray-500",
      on: {
        "click": function($event) {
          return _vm.showStudentVotes(("voting-" + answer + "-" + index))
        }
      }
    }, [_vm._v("\n          Respondents\n          "), (!_vm.opened_votes[("voting-" + answer + "-" + index)]) ? _c('i', {
      staticClass: "fas fa-angle-down p-1"
    }) : _c('i', {
      staticClass: "fas fa-angle-up p-1"
    })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedPoll.votes), function(vote) {
      return (
        _vm.hasTeacherPermissionsInCourse &&
        vote.selections[0] === answer &&
        _vm.opened_votes[("voting-" + answer + "-" + index)]
      ) ? _c('div', {
        key: vote.user_id,
        staticClass: "flex w-full items-center px-3 py-2"
      }, [_c('div', {
        staticClass: "w-7 h-7 rounded-full mr-2",
        style: ({
          backgroundImage: 'url(' + _vm.encodeImageURI(vote.user.avatar_url) + ')',
          'background-size': 'cover',
          'background-position': 'center',
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "text-xs text-gray-500 mx-1"
      }, [_vm._v(_vm._s(vote.user.name))])]) : _vm._e()
    })], 2)
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "flex justify-between items-center pt-5 pb-5 px-7"
  }, [_c('div', [(!_vm.realTimeVote) ? _c('button', {
    staticClass: "py-2 px-5 bg-gray-100 hover:bg-gray-200 rounded text-gray-500 font-semibold mr-2",
    on: {
      "click": function($event) {
        return _vm.closePollDialog()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-2"
  }), _vm._v(" Back To Polls\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "py-2 px-5 bg-red-400 rounded text-white font-semibold",
    on: {
      "click": function($event) {
        return _vm.$emit('deletePoll')
      }
    }
  }, [_vm._v("\n      Delete\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3851209a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/polls_mvp/polls.results.vue
// module id = 1873
// module chunks = 61